import apiService from "../../../services/api";
import {
  CreateBillingTierPayload,
  CreateBillingTierVersionPayload,
  SubscriptionPlansResponse,
  TierDetails,
  TierPricingDetails,
  UpdateBillingTierPayload,
} from "../model/subscription_model";

type TierVersionsResponse =
  | TierPricingDetails[]
  | { versions?: TierPricingDetails[] };

export const SubscriptionApi = {
  async getPricingPlans(): Promise<SubscriptionPlansResponse> {
    const response = await apiService.get("/super-admin/pricing-plans");
    return response.data as SubscriptionPlansResponse;
  },

  async getTier(tierId: string): Promise<TierDetails> {
    return apiService.getAdminBillingTier(tierId) as Promise<TierDetails>;
  },

  async getTierVersions(tierId: string): Promise<TierVersionsResponse> {
    return apiService.getAdminBillingTierVersions(
      tierId,
    ) as Promise<TierVersionsResponse>;
  },

  async createTier(payload: CreateBillingTierPayload): Promise<void> {
    await apiService.createAdminBillingTier(payload);
  },

  async updateTier(
    tierId: string,
    payload: UpdateBillingTierPayload,
  ): Promise<void> {
    await apiService.updateAdminBillingTier(tierId, payload);
  },

  async createTierVersion(
    tierId: string,
    payload: CreateBillingTierVersionPayload,
  ): Promise<void> {
    await apiService.createAdminBillingTierVersion(tierId, payload);
  },

  async deleteTierVersion(versionId: string): Promise<void> {
    await apiService.deleteAdminBillingTierVersion(versionId);
  },
};
